export const append = <T>(arr: Array<T>, item: T): Array<T> => {
  const len = arr.length;
  const result = new Array(len + 1);

  for (let i = 0; i < len; i++) result[i] = arr[i];

  result[len] = item;

  return result;
};

export const prepend = <T>(item: T, arr: Array<T>): Array<T> => {
  const len = arr.length;
  const result = new Array(len + 1);

  result[0] = item;

  for (let i = 0; i < len; i++) result[i + 1] = arr[i];

  return result;
};

export const insertAt = <T>(arr: Array<T>, index: number, val: T): Array<T> => {
  const len = arr.length;

  if (isNaN(index) || index < 0 || index > len) {
    return arr;
  }

  const result = new Array(len + 1);
  let i = 0;

  for (; i < index; i++) result[i] = arr[i];

  result[i] = val;

  for (; i < len; i++) result[i + 1] = arr[i];

  return result;
};

export const updateAt = <T>(
  arr: Array<T>,
  index: number,
  updater: (arg1: T) => T
): Array<T> => {
  if (isNaN(index) || index < 0 || index > arr.length - 1) {
    return arr;
  }

  // @ts-expect-error - TS2345 - Argument of type 'T | undefined' is not assignable to parameter of type 'T'.
  const val = updater(arr[index]);

  if (val === arr[index]) return arr;

  return arr.reduce<Array<T>>((acc, v, i) => {
    if (i === index) acc.push(val);
    else acc.push(v);
    return acc;
  }, []);
};

export const deleteAt = <T>(arr: Array<T>, index: number): Array<T> => {
  if (isNaN(index) || index < 0 || index > arr.length - 1) {
    return arr;
  }

  return arr.reduce<Array<T>>((acc, v, i) => {
    if (i !== index) acc.push(v);
    return acc;
  }, []);
};

export const findLast = <T>(arr: Array<T>, predicate: (item: T) => boolean) => {
  for (let i = arr.length - 1; i >= 0; i--) {
    const item = arr[i];
    // @ts-expect-error - TS2345 - Argument of type 'T | undefined' is not assignable to parameter of type 'T'.
    if (predicate(item)) return item;
  }
};

/**
 * Moves an array element from one index to another.
 * Returns a new array; leaves the old one alone.
 * @param  {Array}  arr         An arbitrary array to operate on.
 * @param  {Number} oldIndex  Old index of the array element to move. Must exist.
 * @param  {Number} newIndex  New array index for the element in oldIndex. Need not be populated yet.
 * @return {Array}            The resulting array after the move.
 */
export function moveElement<T>(
  arr: Array<T>,
  oldIndex: number,
  newIndex: number
): Array<T> {
  arr = arr.slice();

  if (newIndex >= arr.length) {
    let k = newIndex - arr.length;
    while (k-- + 1) {
      // @ts-expect-error - TS2345 - Argument of type 'undefined' is not assignable to parameter of type 'T'.
      arr.push(undefined);
    }
  }
  // @ts-expect-error - TS2345 - Argument of type 'T | undefined' is not assignable to parameter of type 'T'.
  arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
  return arr;
}

/**
 * Filters an array and maps the results to a new array.
 * @param array - The array to filter.
 * @param predicate - A function that determines which elements to include in the new array.
 * @returns A new array containing the elements that satisfy the predicate.
 */
export function filterMap<T, U>(
  array: readonly T[],
  predicate: (
    value: T,
    index: number,
    array: readonly T[]
  ) => U | undefined | null
) {
  const result: U[] = [];
  for (let i = 0; i < array.length; i += 1) {
    const item = array[i]!;
    const value = predicate(item, i, array);
    if (value != null) {
      result.push(value);
    }
  }
  return result;
}
